import { useState } from 'react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Switch } from '@/components/ui/switch';
import { Separator } from '@/components/ui/separator';
import { useToast } from '@/hooks/use-toast';

export function NotificationSettingsTab() {
  const { toast } = useToast();
  const [notifications, setNotifications] = useState({
    messageNotifications: true,
    emailNotifications: false,
    marketingEmails: false,
  });

  const handleToggleNotification = (key: keyof typeof notifications) => {
    setNotifications(prev => ({
      ...prev,
      [key]: !prev[key]
    }));
    
    toast({
      title: '설정 업데이트',
      description: '알림 설정이 업데이트되었습니다.',
    });
  };

  return (
    <div className="space-y-4 pt-4">
      <Card>
        <CardHeader>
          <CardTitle>알림 설정</CardTitle>
          <CardDescription>
            알림 수신 방식을 설정하세요
          </CardDescription>
        </CardHeader>
        <CardContent className="space-y-6">
          <div className="flex items-center justify-between">
            <div className="space-y-0.5">
              <p>앱 푸시 알림</p>
              <p className="text-sm text-muted-foreground">
                새 메시지 및 활동 알림
              </p>
            </div>
            <Switch
              checked={notifications.messageNotifications}
              onCheckedChange={() => handleToggleNotification('messageNotifications')}
            />
          </div>
          <Separator />
          <div className="flex items-center justify-between">
            <div className="space-y-0.5">
              <p>이메일 알림</p>
              <p className="text-sm text-muted-foreground">
                중요 계정 활동 및 보안 알림
              </p>
            </div>
            <Switch
              checked={notifications.emailNotifications}
              onCheckedChange={() => handleToggleNotification('emailNotifications')}
            />
          </div>
          <Separator />
          <div className="flex items-center justify-between">
            <div className="space-y-0.5">
              <p>마케팅 이메일</p>
              <p className="text-sm text-muted-foreground">
                신규 기능 및 프로모션 소식
              </p>
            </div>
            <Switch
              checked={notifications.marketingEmails}
              onCheckedChange={() => handleToggleNotification('marketingEmails')}
            />
          </div>
        </CardContent>
      </Card>
    </div>
  );
}